// extracted by mini-css-extract-plugin
module.exports = {"actionsWrapper":"PreRegisteredDocuments_actionsWrapper__2qCEh"};